// extracted by mini-css-extract-plugin
export default {"text":"ResetPassword_text__2zhKg","restorePasswordError":"ResetPassword_restorePasswordError__dGtcO"};